import { FormGroup } from '@angular/forms';
import { AutoUnsubscribeComponent } from '@wz-utilities/auto-unsubscribe.component';

export abstract class FormGroupBaseComponent<
  T,
> extends AutoUnsubscribeComponent {
  public formGroup!: FormGroup;

  onPatchValue(_data: T, options?: any) {}
}

export function getFormGroupBaseDirective(type: any) {
  return {
    provide: FormGroupBaseComponent,
    useExisting: type,
  };
}
